// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAU_RENI6leojPwWznDEmcngvKEsGCLNiE",
  authDomain: "vividyearapp.firebaseapp.com",
  projectId: "vividyearapp",
  storageBucket: "vividyearapp.firebasestorage.app",
  messagingSenderId: "192486775356",
  appId: "1:192486775356:web:e596d5ba382055912c4139",
  measurementId: "G-3SKYW5SG6N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services and export them
export const analytics = getAnalytics(app);
export const functions = getFunctions(app);